/*!
 * Copyright (c) 2018-present Cyclope.ai
 * LICENSE file is in the root directory of this source tree.
 * */
import * as React from "react";
import { ErrorBoundariesState } from "@Cyclope-Models/index";
// import *as jwt_decode from 'jwt-decode';
import * as Utils from "@Cyclope-Utils/index";
import Particles from "@tunnel-components/@sharded/widgets/particules/component";
// import * as Lodash from 'lodash';
/*
 * Cette classe permet de remonter l'ensemble des erreurs Javascripts
 * Toutes les erreurs Javascripts des enfants sont remonter aux parent
 * Cette classe rend la vue comme un simple composant React
 * @class ErrorBoundaries
 * @extends React.Component
 * @method componentDidCatch
 * @method render
 * @infos "https://reactjs.org/docs/error-boundaries.html"
 */
export class ErrorBoundaries extends React.Component<
  any,
  ErrorBoundariesState
> {
  /**
   * @constructor
   * @param { any } props
   */
  public constructor(props: any) {
    super(props);
    /*
     * @namespace
     * @property { object }      state
     * @property { string }      state.error
     * @property { string }      state.errorInfo
     * @property { boolean}      state.hasError
     */
    this.state = {
      error: "",
      errorInfo: "",
      hasError: false,
    };
    this.onReconnected = this.onReconnected.bind(this);
  }
  /**
   * React gestionnaire d'erreur
   * @method onReconnected
   * @param { any } event
   */
  public onReconnected = (event: any): void => {
    Utils.localStorageClear();
    location.reload();
  };
  /**
   * React gestionnaire d'erreur
   * @method componentDidCatch
   * @param { any } errors
   * @param { any } errorInfos
   */
  public componentDidCatch = (errors: any, errorInfos: any): any => {
    this.setState({
      error: errors,
      errorInfo: errorInfos,
    });
  };

  /**
   * Cycle de vie d'un composant react
   * @method render
   * @param {  }
   */
  public render = () => {
    if (this.state.errorInfo) {
      Utils.fetchLogsFront(window.location.href, this.state.error); // logs des erreurs front
      return (
        <Particles>
          <div
            className="ErrorBoundaries wrapper"
            style={{
              overflow: "hidden",
              position: "relative",
              width: "100%",
              height: "100%",
              background: "linear-gradient(45deg, #007ADF 10%, #00E1B3)",
            }}
          >
            <div
              className="Boundarie"
              style={{
                position: "absolute",
                top: "50%",
                transform: "translateY(-50%)",
                width: "100%",
                height: "auto",
              }}
            >
              <main
                style={{
                  padding: "10px",
                  background: "white",
                  borderRadius: "5px",
                  boxShadow: "0 4px 4px rgba(0, 0, 0, 0.12)",
                  margin: "0 auto",
                  width: "30%",
                  height: "auto",
                }}
              >
                <h1
                  style={{
                    marginBottom: "40px ",
                    textAlign: "center",
                    color: "#555",
                    margin: "0",
                  }}
                >
                  <span style={{ font: "bold 150% sans-serif" }}>
                    Erreur Traitement
                  </span>
                </h1>
                <p
                  style={{
                    textAlign: "center",
                    color: "#555",
                    font: "bold 40px sans-serif",
                    margin: "0",
                  }}
                >
                  ***
                </p>
                <p
                  style={{
                    textAlign: "center",
                    color: "#555",
                    font: "normal 15px sans-serif",
                  }}
                >
                  - Désolé , une erreur est survenue lors du traitement de la
                  demande{" "}
                </p>
                <p
                  style={{
                    textAlign: "center",
                    color: "#777",
                    font: "normal 15px sans-serif",
                    margin: "0",
                  }}
                >
                  - Les causes sont divers: *
                </p>
                <p
                  style={{
                    textAlign: "center",
                    color: "#777",
                    font: "normal 15px sans-serif",
                    margin: "0",
                  }}
                >
                  * ( Un objet qui a changer de forme, un serveur en panne, ...){" "}
                </p>

                <p
                  style={{
                    textAlign: "center",
                    color: "#777",
                    font: "normal 15px sans-serif",
                    margin: "0",
                  }}
                >
                  - Veuillez vous reconnecter{" "}
                </p>
                <p
                  style={{
                    textAlign: "center",
                    color: "#777",
                    font: "normal 15px sans-serif",
                    margin: "0",
                  }}
                >
                  - Ou contacter votre support logiciel{" "}
                </p>

                <nav style={{ marginBottom: "5px", textAlign: "center" }}>
                  <div
                    onClick={this.onReconnected}
                    style={{
                      margin: "15px auto",
                      background: "#007ADF",
                      color: "white",
                      cursor: "pointer",
                      padding: "4px",
                      width: "100px",
                      textAlign: "center",
                      borderRadius: "5px",
                      font: "normal 14px sans-serif",
                    }}
                  >
                    Ok
                  </div>
                </nav>
              </main>
            </div>
          </div>
        </Particles>
      );
    }

    if (this.state.error) {
      Utils.localStorageClear();
    }

    return this.props.children;
  };
}



// WEBPACK FOOTER //
// ./src/ErrorBoundaries/index.tsx